export default {
  path: '/2019NewWishes',
  name: '2019NewWishes',
  component: () => import('./Home.vue'),
  redirect: '/2019NewWishes/ListPage',
  meta: {
    title: '@2020重庆·我的新期待',
  },
  children: [
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: 'ListPAge',
      meta: {
        title: '@2020重庆·我的新期待',
      },
    },
  ],
};
